import { createContext, useContext, useState } from 'react';

import { urlConfig } from '../../config/urlConfig';
import {
  accessTokenRequest,
  getUserData,
  sendRequest,
} from '../global/global.service';

import { ProfileContext } from '../profile/profile.context';

export const CommentContext = createContext();

export const CommentContextProvider = ({ children }) => {
  const { user } = useContext(ProfileContext);
  const [comments, setComments] = useState([]);
  const [replies, setReplies] = useState([]);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');
  const [isCommentLoading, setIsCommentLoading] = useState(false);
  const [isReplyLoading, setIsReplyLoading] = useState(false);

  const getMeetingComments = (id) => {
    let commentsArr = [];
    let repliesArr = [];

    accessTokenRequest()
      .then((response) => {
        sendRequest(`${urlConfig.get_comment_url}${id}`, response, 'get', null)
          .then((res) => {
            res.data.map((comment) => {
              if (comment.level === 0) {
                commentsArr.push(comment);
              } else if (comment.level === 1) {
                repliesArr.push(comment);
              }
            });

            getUsers(res.data, response);
            setComments(commentsArr);
            setReplies(repliesArr);
          })
          .catch((err) => {
            setError(err.toString());
            console.log(err);
          });
      })
      .catch((err) => {
        console.log('get token err', err);
      });
  };

  //Get uuid to get user information
  const getUsers = (comments, response) => {
    let uids = [];
    //get user uid from comments
    comments.length > 0 &&
      comments.map((user) => user.user_uuid && uids.push(user.user_uuid));

    //get users data
    if (uids.length > 0) {
      getUserData(
        {
          users_uuids: uids,
        },
        response
      )
        .then((res) => {
          res.data &&
            res.data.members &&
            res.data.members.length > 0 &&
            setUsers(res.data.members);
        })
        .catch((e) => {});
    }
  };

  const addComment = (e, id, comment, setComment) => {
    e.preventDefault();

    let newComments = comments;

    let commentData = {
      object_pk: parseInt(id),
      comment: comment,
      name: user && user.username,
      email: user && user.email,
      content_type: 'meeting.meeting',
      user_uuid: user && user.uid,
      reply_to: 0,
    };

    if (comment && user && user.uid) {
      setIsCommentLoading(true);

      accessTokenRequest()
        .then((response) => {
          sendRequest(urlConfig.send_comment_url, response, 'post', commentData)
            .then((result) => {
              setComment('');
              if (result && result.data) {
                newComments.push(result.data);
                setComments(newComments);

                //refresh comments
                getMeetingComments(id);
              }
              setIsCommentLoading(false);
            })
            .catch((e) => {
              setIsCommentLoading(false);
              // setError(e.toString());
            });
        })
        .catch((e) => {
          setIsCommentLoading(false);
          // setError(e.toString());
        });
    }
  };

  const addReply = (e, id, reply, comment, setReply, setOpen) => {
    e.preventDefault();
    let newReplies = replies;
    // setLoading(true);

    const replyData = {
      object_pk: parseInt(id),
      reply_to: comment.parent_id,
      comment: reply,
      name: user && user.username,
      user_uuid: user && user.uid,
      email: user && user.email,
      content_type: 'meeting.meeting',
      level: 1,
    };

    if (reply && user && user.uid) {
      setIsReplyLoading(true);

      accessTokenRequest()
        .then((response) => {
          sendRequest(urlConfig.send_comment_url, response, 'post', replyData)
            .then((reply) => {
              setOpen(false);
              setIsReplyLoading(false);
              setReply('');
              newReplies.push(reply.data);
              setReplies(newReplies);
              //refresh comments
              getMeetingComments(id);
              // submit_date: moment(reply.data.submit_date).format(
              //   'MMMM. DD, YYYY, HH:mm A'
              // ),
            })
            .catch((e) => {
              setIsReplyLoading(false);
            });
        })
        .catch((e) => {
          setIsReplyLoading(false);
        });
    }
  };

  return (
    <CommentContext.Provider
      value={{
        replies,
        comments,
        error,
        users,
        isCommentLoading,
        isReplyLoading,
        setUsers,
        setReplies,
        setComments,
        getMeetingComments,
        addComment,
        addReply,
      }}
    >
      {children}
    </CommentContext.Provider>
  );
};
